/**
 * Public Routes Configuration
 * Routes that don't require authentication
 *
 * Used by:
 * - AuthContext: for automatic redirect logic
 * - AppLayout: for conditional menu rendering
 */
import { navigation } from '@/navigation';

export const PUBLIC_ROUTES = [
  navigation.signIn(),
  navigation.passwordSignIn(),
  navigation.signUp(),
  navigation.forgotPassword(),
  navigation.verifyEmail(),
  navigation.verificationPending(),
  navigation.acceptInvitation(),
  navigation.impersonateCallback(),
  navigation.magicLinkSent(),
  navigation.magicLinkCallback(),
  navigation.termsOfService(),
  navigation.policies(),
  navigation.unsubscribe()
] as const;

/**
 * Check if a given pathname is a public route
 * @param pathname - The pathname to check
 * @returns True if the pathname is a public route
 */
export function isPublicRoute(pathname: string): boolean {
  return PUBLIC_ROUTES.some(route => pathname === route || pathname.startsWith(route));
}
